import React, { useState, useEffect } from 'react';
import { FaTemperatureHigh, FaTint, FaDesktop } from "react-icons/fa";
const SpaceViewer = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("1/F");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [expandedSubcategories, setExpandedSubcategories] = useState({});


  // SVG icons
  const availableIcon = (
    <svg
      width="48"
      height="32"
      viewBox="0 0 70 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="15" cy="10" r="7" fill="#4ade80" /> 
        <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#4ade80" />{" "}
        <circle
          cx="35"
          cy="8"
          r="7"
          stroke="#4ade80"
          strokeWidth="1.5"
          fill="none"
        />{" "}
     
        <path
          d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z"
          stroke="#4ade80"
          strokeWidth="1.5"
          fill="none"
        />{" "}
     
        <circle
          cx="55"
          cy="10"
          r="7"
          stroke="#4ade80"
          strokeWidth="1.5"
          fill="none"
        />{" "}

        <path
          d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z"
          stroke="#4ade80"
          strokeWidth="1.5"
          fill="none"
        />{" "}

      </g>
    </svg>
  );
 
  const lessAvailableIcon = (
    <svg
      width="48"
      height="32"
      viewBox="0 0 70 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>

        <circle cx="15" cy="10" r="7" fill="#fbbf24" /> 
        <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#fbbf24" />{" "}
      
        <circle cx="35" cy="8" r="7" fill="#fbbf24" /> 
        <path
          d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z"
          fill="#fbbf24"
        />{" "}
       
        <circle
          cx="55"
          cy="10"
          r="7"
          stroke="#fbbf24"
          strokeWidth="1.5"
          fill="none"
        />{" "}

        <path
          d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z"
          stroke="#fbbf24"
          strokeWidth="1.5"
          fill="none"
        />{" "}
      </g>
    </svg>
  );
 
  const crowdedIcon = (
    <svg
      width="48"
      height="32"
      viewBox="0 0 70 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>

        <circle cx="15" cy="10" r="7" fill="#ef4444" />
        <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#ef4444" />{" "}

        <circle cx="35" cy="8" r="7" fill="#ef4444" /> 
        <path
          d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z"
          fill="#ef4444"
        />{" "}

        <circle cx="55" cy="10" r="7" fill="#ef4444" /> 
        <path
          d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z"
          fill="#ef4444"
        />{" "}
 
      </g>
    </svg>
  );

  // Zone data with _(hardcoded
  const zoneData = {
    "1/F": {
      "Zone A": { temp: 22, humidity: 64, co2: 575, occupancy: "available" },
      "Zone B": { temp: 24, humidity: 74, co2: 2118, occupancy: "crowded" },
      "Zone C": { temp: 23, humidity: 70, co2: 1185, occupancy: "lessAvailable" }
    },
    "M/F": {
      "Zone A": { temp: 24, humidity: 68, co2: 650, occupancy: "crowded" },
      "Zone B": { temp: 21, humidity: 65, co2: 890, occupancy: "lessAvailable" }
    },
    "2/F": {
      "Zone A": { temp: 21, humidity: 60, co2: 720, occupancy: "available" },
      "Zone B": { temp: 21, humidity: 62, co2: 780, occupancy: "available" },
      "Zone C": { temp: 22, humidity: 68, co2: 850, occupancy: "lessAvailable" }
    },
    "3/F": {
      "Zone A": { temp: 23, humidity: 63, co2: 680, occupancy: "available" },
      "Zone B": { temp: 23, humidity: 65, co2: 710, occupancy: "available" },
      "Zone C": { temp: 22, humidity: 66, co2: 840, occupancy: "available" }
    }
  };

  //  areas that can be highlighted in the 3D viewer
  // const [areas] = useState([
  //   { name: "Service Counter", handler: () => console.log("Showing Service Counter") },
  //   { name: "Study Rooms", handler: () => console.log("Showing Study Rooms") },
  //   { name: "Cafeteria", handler: () => console.log("Showing Cafeteria") },
  // ]);
  
  // categories and subcategories for the multilevel dropdown
  const [categories] = useState([
    {
      name: "Service Counter",
      subcategories: []
    },
    {
      name: "Collections",
      subcategories: [
        { 
          name: "Books A-Z", 
          zone: "1/F Zone A",
          subItems: [
            { name: "Books A-DS776 (1/F Zone A)", zone: "" },
            { name: "Books DS777-HJ (1/F Zone C)", zone: "" },
            { name: "Books HM-HM1100 (M/F Zone B)", zone: "" },
            { name: "Books HM1101-HN (2/F Zone B)", zone: "" },
            { name: "Books HN-HS (3/F Zone A)", zone: "" },
            { name: "Books HT-NX (3/F Zone B)", zone: "" },
            { name: "Books P-ZA (3/F Zone C)", zone: "" }
          ]
        },
        { name: "Course Reserves", zone: "1/F Zone A" },
        { name: "Good Reads, New Arrivals", zone: "1/F Zone B" },
        { name: "High Use Books", zone: "1/F Zone B" },
        { name: "Journals [SER]", zone: "2/F Zone A" },
        { name: "Language Examinations & Learning Resources [LANG]", zone: "2/F Zone C" },
        { name: "Large Books [LBK], Extra Large Books [XLBK]", zone: "3/F Zone A" },
        { name: "Lingnan University Archives", zone: "2/F Zone A" },
        { name: "Multimedia [AVM]", zone: "" },
        { name: "Newspapers", zone: "" },
        { name: "References [REF]", zone: "" },
        { name: "Staff Publications", zone: "1/F Zone B" }
      ]
    },
    {
      name: "Computers",
      subcategories: []
    },
    {
      name: "MultiFunction Printers",
      subcategories: []
    },
    {
      name: "Study Rooms",
      subcategories: []
    },
    {
      name: "Study Spaces",
      subcategories: []
    },
    {
      name: "Drinking Water Stations",
      subcategories: []
    },
    {
      name: "Toilets",
      subcategories: []
    },
    {
      name: "Other Facilities",
      subcategories: []
    }
  ]);

  const [filteredCategories, setFilteredCategories] = useState(categories);

  

  // filter categories based on search term
  useEffect(() => {
    if (!searchTerm) {
      setFilteredCategories(categories);
      return;
    }
    
    const filtered = categories.filter(category => {
      // check if category name matches
      if (category.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return true;
      }
      
      // check if any subcategory matches
      if (category.subcategories && category.subcategories.length > 0) {
        const hasMatchingSubcategory = category.subcategories.some(
          subcategory => {
            if (subcategory.name.toLowerCase().includes(searchTerm.toLowerCase())) {
              return true;
            }
            
            // check for sub-items matches
            if (subcategory.subItems && subcategory.subItems.length > 0) {
              return subcategory.subItems.some(
                subItem => subItem.name.toLowerCase().includes(searchTerm.toLowerCase())
              );
            }
            
            return false;
          }
        );
        return hasMatchingSubcategory;
      }
      
      return false;
    });
    
    setFilteredCategories(filtered);
  }, [searchTerm, categories]);

  // toggle expansion of category
  const toggleCategory = (categoryName) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryName]: !prev[categoryName]
    }));
  };
  
  // toggle expansion of subcategory
  const toggleSubcategory = (subcategoryName) => {
    setExpandedSubcategories(prev => ({
      ...prev,
      [subcategoryName]: !prev[subcategoryName]
    }));
  };

  // change floor level
  const changeLevel = (level) => {
    setSelectedLevel(level);
    // would add functionality to change the floor in the 3D viewer
  };

  // helper function to render occupancy icon based on status
  const renderOccupancyIcon = (status) => {
    switch (status) {
      case "available":
        return availableIcon;
      case "lessAvailable":
        return lessAvailableIcon;
      case "crowded":
        return crowdedIcon;
      default:
        return availableIcon;
    }
  };

  // helper function to render CO2 level icon based on ppm
  const renderCO2StatusIcon = (ppm) => {
    if (ppm < 800) {
      return (
        <svg width="38" height="38" viewBox="0 0 24 24" fill="#4ade80" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#4ade80" strokeWidth="2" fill="none" />
          <path d="M7,13 C9,17 15,17 17,13" stroke="#4ade80" strokeWidth="2" strokeLinecap="round" fill="none" />
          <circle cx="8" cy="9" r="1.5" fill="#4ade80" />
          <circle cx="16" cy="9" r="1.5" fill="#4ade80" />
        </svg>
      );
    } else if (ppm < 1500) {
      return (
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#fbbf24" strokeWidth="2" fill="none" />
          <path d="M8,14 L16,14" stroke="#fbbf24" strokeWidth="2" />
          <circle cx="8" cy="9" r="1" fill="#fbbf24" />
          <circle cx="16" cy="9" r="1" fill="#fbbf24" />
        </svg>
      );
    } else {
      return (
        <svg width="38" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" fill="none"  />
          <path d="M8,16 C8,14 16,14 16,16" stroke="#ef4444" strokeWidth="2" fill="none" />
          <circle cx="8" cy="9" r="1" fill="#ef4444" />
          <circle cx="16" cy="9" r="1" fill="#ef4444" />
        </svg>
      );
    }
  };

  // helper function to calculate average temperature for a floor
  const getFloorAverageTemp = (floor) => {
    if (!zoneData[floor]) return 0;
    
    const zones = Object.keys(zoneData[floor]);
    if (zones.length === 0) return 0;
    
    const sum = zones.reduce((acc, zone) => acc + zoneData[floor][zone].temp, 0);
    return Math.round(sum / zones.length);
  };

  // helper function to determine overall floor occupancy
  const getFloorOccupancy = (floor) => {
    if (!zoneData[floor]) return "available";
    
    const zones = Object.keys(zoneData[floor]);
    if (zones.length === 0) return "available";
    
    const occupancyCount = {
      available: 0,
      lessAvailable: 0,
      crowded: 0
    };
    
    zones.forEach(zone => {
      occupancyCount[zoneData[floor][zone].occupancy]++;
    });
    
    // determine overall occupancy based on highest count 
    if (occupancyCount.crowded > 0) return "crowded";
    if (occupancyCount.lessAvailable > occupancyCount.available) return "lessAvailable";
    return "available";
  };

  const getCurrentDate = () => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const now = new Date();
    const day = now.getDate();
    const month = months[now.getMonth()];
    const year = now.getFullYear();
    const weekday = days[now.getDay()];
    
    return `${day} ${month} ${year} ${weekday}`;
  };

  return (
    <div className="flex flex-col h-screen">
      {/* header */}
      <header className="bg-white custom-shadow h-20 xl:h-[100px] fixed top-0 left-0 w-full z-10 flex items-center justify-between px-4">
        <div className="flex items-center h-full">
          <img 
            src="/library-logo-final_2024.png" 
            alt="Lingnan University Fong Sum Wood Library" 
            className="h-10 xl:h-[58px]"
          />
        </div>

        <div className="flex items-center gap-5">
        <div className="text-gray-600 mr-4">
            <div className="text-xl font-medium"> {getCurrentDate()}</div>
          </div>
          <div className="flex items-center">
            <FaTemperatureHigh className="w-7 h-7 text-amber-500" />
            <div className="ml-1">
              <span className="text-2xl font-bold text-amber-500">29</span>
              <span className="text-xl text-amber-500">°C</span>
              <div className="text-xs text-gray-500">Temperature</div>
            </div>
          </div>
          <div className="flex items-center">
          <FaTint className="w-7 h-7 text-blue-500" />
            <div className="ml-1">
              <span className="text-2xl font-bold text-blue-500">82</span>
              <span className="text-xl text-blue-500">%</span>
              <div className="text-xs text-gray-500">Relative Humidity</div>
            </div>
          </div>
        </div>
      </header>
      
      {/* tempand banner */}
      <div className="bg-white p-3 flex justify-between items-center border-b mt-14 lg:mt-20 xl:mt-[100px]">
        <div className="text-gray-600 text-sm lg:text-base"><span className='font-bold text-teal-600'>Today's Opening Hours:</span> 8:30 a.m. - 9:00 p.m. (Overnight Study Area Open)</div>
        
      </div>
      
      {/* floor selector */}
      <div className="flex space-x-2 p-3 bg-white custom-shadow">
        <button 
          onClick={() => changeLevel("1/F")}
          className={`rounded-full px-6 py-2 ${selectedLevel === "1/F" ? "bg-transparent border-2 border-teal-600 font-medium text-teal-600" : "bg-gray-200 text-gray-600"}`}
        >
          1/F
        </button>
        <button 
          onClick={() => changeLevel("M/F")}
          className={`rounded-full px-6 py-2 ${selectedLevel === "M/F" ? "bg-transparent border-2 border-teal-600 font-medium text-teal-600" : "bg-gray-200 text-gray-600"}`}
        >
          M/F
        </button>
        <button 
          onClick={() => changeLevel("2/F")}
          className={`rounded-full px-6 py-2 ${selectedLevel === "2/F" ? "bg-transparent border-2 border-teal-600 font-medium text-teal-600" : "bg-gray-200 text-gray-600"}`}
        >
          2/F
        </button>
        <button 
          onClick={() => changeLevel("3/F")}
          className={`rounded-full px-6 py-2 ${selectedLevel === "3/F" ? "bg-transparent border-2 border-teal-600 font-medium text-teal-600" : "bg-gray-200 text-gray-600"}`}
        >
          3/F
        </button>
      </div>
      
      {/* main content - map and search facility */}
      <div className="flex">
        {/* 3d Viewer (75% width) */}
<div className="w-3/4 h-[70vh]">
  <iframe
    id="iframe"
    src="https://pwwpdev.github.io/Lingnan/first_floor_dos_public_test.html"
    className="w-full h-full border-0"
    title="3D Library Map"
  />
</div>
        
        {/* right panel with search and categories (25% width) */}
        <div className="w-1/4 h-[70vh] flex flex-col border-l bg-white border-gray-300 ">
          {/* search input */}
          <div className="p-3 border-b border-gray-200">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                className="w-full px-8 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Search Location / Facility"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className="absolute right-3 top-2 text-gray-400 hover:text-gray-600"
                  onClick={() => setSearchTerm("")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
          
          {/* categories and subcategories(scrollable) */}
          <div className="overflow-y-auto flex-1">
            {filteredCategories.map((category, index) => (
              <div key={index} className="border-b border-gray-200">
                <div 
                  className={`p-3 flex items-center justify-between cursor-pointer ${
                    category.name === "Service Counter" || 
                    category.name === "Study Rooms" || 
                    category.name === "Computers" || 
                    category.name === "Study Spaces" || 
                    category.name === "Drinking Water Stations" ? 
                    "bg-teal-600 text-white" : "hover:bg-gray-50"
                  }`}
                  onClick={() => toggleCategory(category.name)}
                >
                  <span className="font-medium text-sm">{category.name}</span>
                  {category.subcategories && category.subcategories.length > 0 && (
                    <svg
                      className={`w-4 h-4 transition-transform ${
                        expandedCategories[category.name] ? "transform rotate-90" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  )}
                </div>
                
                {/* subcategories */}
                {expandedCategories[category.name] && category.subcategories && (
                  <div className="bg-gray-50">
                    {category.subcategories.map((subcategory, subIndex) => (
                      <div key={subIndex}>
                        <div
                          className="p-2 pl-6 border-t border-gray-200 hover:bg-gray-100 flex items-center justify-between cursor-pointer"
                          onClick={() => {
                            if (subcategory.subItems && subcategory.subItems.length > 0) {
                              toggleSubcategory(subcategory.name);
                            }
                          }}
                        >
                          <div>
                            <div className="font-medium text-xs">{subcategory.name}</div>
                            {subcategory.zone && (
                              <div className="text-xs text-gray-500">{subcategory.zone}</div>
                            )}
                          </div>
                          {subcategory.subItems && subcategory.subItems.length > 0 ? (
                            <svg
                              className={`w-3 h-3 text-gray-400 transition-transform ${
                                expandedSubcategories[subcategory.name] ? "transform rotate-90" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          ) : (
                            <svg
                              className="w-3 h-3 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          )}
                        </div>
                        
                        {/* third level - sub-items */}
                        {expandedSubcategories[subcategory.name] && subcategory.subItems && (
                          <div className="bg-gray-100">
                            {subcategory.subItems.map((subItem, subItemIndex) => (
                              <div
                                key={subItemIndex}
                                className="p-2 pl-10 border-t border-gray-200 hover:bg-gray-200 flex items-center justify-between cursor-pointer"
                                onClick={() => {}}
                              >
                                <div>
                                  <div className="font-medium text-xs">{subItem.name}</div>
                                  {subItem.zone && (
                                    <div className="text-xs text-gray-500">{subItem.zone}</div>
                                  )}
                                </div>
                                <svg
                                  className="w-3 h-3 text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 5l7 7-7 7"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Zone Info */}
<div className="bg-gray-50 p-3 border-t border-gray-300">
  <h2 className="text-lg font-semibold text-gray-700 mb-2">Floor {selectedLevel} Zones</h2>
  <div className="grid grid-cols-3 gap-4">
    {Object.keys(zoneData[selectedLevel] || {}).map((zone, index) => {
      const data = zoneData[selectedLevel][zone];
      return (
        <div key={index} className="bg-white rounded-lg shadow-sm p-3 border border-gray-200">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium text-lg text-gray-700">{zone}</h3>
            <div className="origin-right">
              {renderOccupancyIcon(data.occupancy)}
            </div>
          </div>
          
          <div className="grid grid-cols-3 gap-2">
            {/* Temperature */}
            <div className="text-center">
              <div className="text-3xl font-bold text-gray-700">{data.temp}°C</div>
              <div className="text-sm text-gray-500">Temperature</div>
            </div>
            
            {/* Humidity */}
            <div className="text-center">
              <div className="text-3xl font-bold text-gray-700">{data.humidity}%</div>
              <div className="text-sm text-gray-500">Humidity</div>
            </div>
            
            {/* CO2 Data */}
            <div className="text-center">
              <div className="flex items-center justify-center">
                <div className="text-3xl font-bold text-gray-700 mr-1">{data.co2}</div>
                <div className="scale-75">
                  {renderCO2StatusIcon(data.co2)}
                </div>
              </div>
              <div className="text-sm text-gray-500">
                CO₂ ppm {data.co2 < 800 ? "(Good)" : data.co2 < 1500 ? "(Fair)" : "(Poor)"}
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>
      
     {/* floor Summary Section */}
<div className="w-full p-4 bg-white border-t border-gray-200">
  <div className="flex justify-between space-x-4">
    {/* 1/F Card */}
    <div 
      className={`relative rounded-xl p-3 flex-1 ${selectedLevel === "1/F" ? "bg-blue-100" : "bg-white border border-gray-200"}`}
      onClick={() => changeLevel("1/F")}
    >
      <div className="text-lg font-semibold text-gray-700">1/F</div>
      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center">
        <FaTemperatureHigh className="w-7 h-7 text-amber-500" />
          <div className="ml-2">
            <div className="text-2xl font-bold text-gray-700">24°C</div>
            <div className="text-xs text-gray-500">Temperature</div>
          </div>
        </div>
        <svg width="58" height="38" viewBox="0 0 70 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            {/* First person - colored */}
            <circle cx="15" cy="10" r="7" fill="#ef4444" />
            <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#ef4444" />
            {/* Second person - colored */}
            <circle cx="35" cy="8" r="7" fill="#ef4444" />
            <path d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z" fill="#ef4444" />
            {/* Third person - colored */}
            <circle cx="55" cy="10" r="7" fill="#ef4444" />
            <path d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z" fill="#ef4444" />
          </g>
        </svg>
      </div>
    </div>

    {/* M/F Card */}
    <div 
      className={`relative rounded-xl p-3 flex-1 ${selectedLevel === "M/F" ? "bg-blue-50" : "bg-white border border-gray-200"}`}
      onClick={() => changeLevel("M/F")}
    >
      <div className="text-lg font-semibold text-gray-700">M/F</div>
      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center">
        <FaTemperatureHigh className="w-7 h-7 text-amber-500" />
          <div className="ml-2">
            <div className="text-2xl font-bold text-gray-700">21°C</div>
            <div className="text-xs text-gray-500">Temperature</div>
          </div>
        </div>
        <svg width="58" height="38" viewBox="0 0 70 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            {/* First person - colored */}
            <circle cx="15" cy="10" r="7" fill="#fbbf24" />
            <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#fbbf24" />
            {/* Second person - colored */}
            <circle cx="35" cy="8" r="7" fill="#fbbf24" />
            <path d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z" fill="#fbbf24" />
            {/* Third person - outline */}
            <circle cx="55" cy="10" r="7" stroke="#fbbf24" strokeWidth="1.5" fill="none" />
            <path d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z" stroke="#fbbf24" strokeWidth="1.5" fill="none" />
          </g>
        </svg>
      </div>
    </div>

    {/* 2/F Card */}
    <div 
      className={`relative rounded-xl p-3 flex-1 ${selectedLevel === "2/F" ? "bg-blue-50" : "bg-white border border-gray-200"}`}
      onClick={() => changeLevel("2/F")}
    >
      <div className="text-lg font-semibold text-gray-700">2/F</div>
      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center">
        <FaTemperatureHigh className="w-7 h-7 text-amber-500" />
          <div className="ml-2">
            <div className="text-2xl font-bold text-gray-700">21°C</div>
            <div className="text-xs text-gray-500">Temperature</div>
          </div>
        </div>
        <svg width="58" height="38" viewBox="0 0 70 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            {/* First person - colored */}
            <circle cx="15" cy="10" r="7" fill="#4ade80" />
            <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#4ade80" />
            {/* Second person - outline */}
            <circle cx="35" cy="8" r="7" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            <path d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            {/* Third person - outline */}
            <circle cx="55" cy="10" r="7" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            <path d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z" stroke="#4ade80" strokeWidth="1.5" fill="none" />
          </g>
        </svg>
      </div>
    </div>

    {/* 3/F Card */}
    <div 
      className={`relative rounded-xl p-3 flex-1 ${selectedLevel === "3/F" ? "bg-blue-50" : "bg-white border border-gray-200"}`}
      onClick={() => changeLevel("3/F")}
    >
      <div className="text-lg font-semibold text-gray-700">3/F</div>
      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center">
        <FaTemperatureHigh className="w-7 h-7 text-amber-500" />
          <div className="ml-2">
            <div className="text-2xl font-bold text-gray-700">23°C</div>
            <div className="text-xs text-gray-500">Temperature</div>
          </div>
        </div>
        <svg width="58" height="38" viewBox="0 0 70 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            {/* First person - colored */}
            <circle cx="15" cy="10" r="7" fill="#4ade80" />
            <path d="M7,20 Q15,13 23,20 L23,32 Q15,36 7,32 Z" fill="#4ade80" />
            {/* Second person - outline */}
            <circle cx="35" cy="8" r="7" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            <path d="M27,18 Q35,11 43,18 L43,30 Q35,34 27,30 Z" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            {/* Third person - outline */}
            <circle cx="55" cy="10" r="7" stroke="#4ade80" strokeWidth="1.5" fill="none" />
            <path d="M47,20 Q55,13 63,20 L63,32 Q55,36 47,32 Z" stroke="#4ade80" strokeWidth="1.5" fill="none" />
          </g>
        </svg>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default SpaceViewer;